import { computed, action } from 'mobx';
import { MobxFieldControl } from '@app/src/common/components/form/MobxFieldControl';

const MIN_CHARS = 10;
const ONE_NUMBER_REGEX = /\d/;
const ONE_UPPERCASE_CHAR_REGEX = /[A-ZÄÖÜẞ\u0410-\u042F]/;
const ONE_LOWERCASE_CHAR_REGEX = /[a-zäöüß\u0430-\u044F]/;

export function NewPasswordField() {
  return (target: any, name: string) => {
    if (!target[name]) {
      Object.defineProperty(target, name, {
        enumerable: true,
        configurable: true,
        value: new NewPasswordFieldControl() as MobxFieldControl
      });
    }
  };
}

class NewPasswordFieldControl extends MobxFieldControl {
  constructor(...args: any[]) {
    super(args);
  }

  @computed get moreThanTenChars(): boolean {
    return this._value.length >= MIN_CHARS;
  }

  @computed get hasOneNumber(): boolean {
    return ONE_NUMBER_REGEX.test(this._value);
  }

  @computed get hasOneUppercaseChar(): boolean {
    return ONE_UPPERCASE_CHAR_REGEX.test(this._value);
  }

  @computed get hasOneLowercaseChar(): boolean {
    return ONE_LOWERCASE_CHAR_REGEX.test(this._value);
  }

  @action
  clear() {
    this._value = '';
    this.isTouched = false;
  }
}

export default NewPasswordFieldControl;
